import styled from 'styled-components';

import { SortMode } from '@qality/common-model/src/sorting/Sort';

export const IconContainerStyled = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const IconStyled = styled.div`
  width: 16px;
  height: 10px;
  position: relative;
`;

const TriangleStyled = styled.div`
  position: absolute;
  width: 0;
  border-style: solid;
`;

type TriangleProps = {
  sortMode: SortMode;
};

const TriangleColors: Record<SortMode, { top: string; bottom: string }> = {
  asc: {
    top: 'var(--ds-icon, var(--ds-fb-icon))',
    bottom: 'var(--ds-icon-disabled, var(--ds-fb-icon-disabled))',
  },
  dsc: {
    top: 'var(--ds-icon-disabled, var(--ds-fb-icon-disabled))',
    bottom: 'var(--ds-icon, var(--ds-fb-icon))',
  },
  none: {
    top: 'var(--ds-icon-disabled, var(--ds-fb-icon-disabled))',
    bottom: 'var(--ds-icon-disabled, var(--ds-fb-icon-disabled))',
  },
};

export const TopTriangleStyled = styled(TriangleStyled)<TriangleProps>`
  top: 0;
  left: 0;
  border-width: 0 4px 4px 4px;
  border-color: transparent transparent
    ${({ sortMode }) => TriangleColors[sortMode].top} transparent;
`;

export const BottomTriangleStyled = styled(TriangleStyled)<TriangleProps>`
  top: 6px;
  left: 0;
  border-width: 4px 4px 0 4px;
  border-color: ${({ sortMode }) => TriangleColors[sortMode].bottom} transparent
    transparent transparent;
`;
